var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as actions from 'app/actions/settings';
import http from 'app/services/http';
export const settingsReducer = (state = {
    keys: {},
}, action) => {
    switch (action.type) {
        case 'SETTINGS_SET_KEYS': {
            const { keys } = action.payload;
            return Object.assign(Object.assign({}, state), { keys: keys });
        }
        default:
            return state;
    }
};
export function settingsLoad() {
    return function settingsLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/settings');
            return dispatch(actions.setKeys(data));
        });
    };
}
export function settingsUpdate(params) {
    return function settingsUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put('/settings', params);
            return dispatch(actions.setKeys(data));
        });
    };
}
export default settingsReducer;
